// extracted by mini-css-extract-plugin
export default {"wrapNoti":"notification_wrapNoti__m4P1s"};